<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent1"><a id="page_i">Dear Reader,</a></p><a id="page_i">
<p class="noindent">When Pocket Books decided to bring <span class="txit">Stormswept</span> back into print, I was thrilled at the chance to revise and refresh another novel I’d penned long ago under the name Deborah Martin. My early works set the stage for my career to come: first, the historical detail, passionate action, and darker tone of the Deborah Martin novels. And later on, the sensual entanglements, witty repartee, and lighthearted spirit of my recent Regency series, the Sinful Suitors and the Hellions of Halstead Hall. Both styles are infused with the sexy romantic liaisons my readers have come to expect in my books.</p>
<p class="indentb1">In <span class="txit">Stormswept,</span> Lady Juliana St. Albans is reunited with dark and daring Rhys Vaughan, the husband she thought had abandoned her after their wedding night years ago. Battling mistrust, yet longing for the love they once shared, they must unravel a maze of mystery and menace to find love again. In this tale of desire and deception, I heightened the drama, enriched the story line, tightened the dialogue, and stoked the heart-pounding sexual tension between these entangled characters. I hope you enjoy this story, whether it’s a past favorite or a new adventure for you to relish!</p>
<p class="right1">Sincerely,</p>
<p class="imagea"><img alt="Images" src="images/sign.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// reader.vue?173f3573